export const MAX_NUMBER_DOCUMENTS = 10;
export const MAX_FILE_SIZE = 5; // 5MB
export const ACCEPTED_FILES = [
  {
    fileName: 'JPG',
    fileType: 'image/jpeg',
  },
  // NOTE: currenly only support JPG
  // {
  //   fileName: 'PNG',
  //   fileType: 'image/png',
  // },
  // {
  //   fileName: 'PDF',
  //   fileType: 'application/pdf',
  // },
];
